<div class="model d-flex flex-column align-items-center justify-content-center">
  <div class="mt-2">
    <img src="assets/img/logo1.png" alt="" height="35" class="w-80">
  </div>
  <h2 class="text-center mt-2">
    You've Been <strong class="font-bold">Idle</strong>
  </h2>
  <p class="text-center mt-2 modal-message">
    For your security, you'll be logged out in <strong><span id="countdown" class="countdown-text">{{ countdown }}</span> seconds</strong>,
    Click on Continue to stay signed in.
  </p>
  <button class="btn btn-primary mt-2" (click)="onContinue()" >Continue</button>
</div>